/* eslint-disable */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'index.js';
import { apiUrl } from 'App.js';

export const fetchBrandList = createAsyncThunk(
  'brandlist/post',
  async (_, thunkAPI) => {
    const { channel } = thunkAPI.getState().currentchannel;
    const { yearMonth } = thunkAPI.getState().currentsection;
    const currentCategories = thunkAPI.getState().categorygraph;
    const pageCount = thunkAPI.getState().brand.pageCount;
    const res = await client.post(`${apiUrl}brand/list`, {
      channel: channel,
      term: yearMonth,
      categories: currentCategories,
      pageCount: pageCount
    });
    return res.data;
  }
);

export const fetchSearchBrandList = createAsyncThunk(
  '/brandlist/search',
  async (arg, thunkAPI) => {
    const { keyword } = arg;
    const { channel } = thunkAPI.getState().currentchannel;
    const { yearMonth } = thunkAPI.getState().currentsection;
    const currentCategories = thunkAPI.getState().categorygraph;
    const pageCount = thunkAPI.getState().brand.pageCount;
    const res = await client.post(`${apiUrl}brand/list/search`, {
      channel: channel,
      term: yearMonth,
      categories: currentCategories,
      pageCount: pageCount,
      keyword: keyword
    });
    return res.data;
  }
);

const brandSlice = createSlice({
  name: 'brand',
  initialState: {
    brandList: {
      amazon: [],
      rakuten: [],
      yahoo: []
    },
    ownSelectedBrand: {
      amazon: '',
      rakuten: '',
      yahoo: ''
    },
    ownCheckedBrand: {
      amazon: '',
      rakuten: '',
      yahoo: ''
    },
    otherSelectedBrand: {
      amazon: '',
      rakuten: '',
      yahoo: ''
    },
    otherCheckedBrand: {
      amazon: '',
      rakuten: '',
      yahoo: ''
    },
    allBrandLength: {
      amazon: '',
      rakuten: '',
      yahoo: ''
    },
    pageCount: 1,
    isLoading: false
  },
  reducers: {
    setOwnSelectedBrandList(state, action) {
      if (action.payload.channel == 1) {
        state.ownSelectedBrand.amazon = action.payload.list;
      } else if (action.payload.channel == 2) {
        state.ownSelectedBrand.rakuten = action.payload.list;
      } else if (action.payload.channel == 3) {
        state.ownSelectedBrand.yahoo = action.payload.list;
      }
    },
    setOtherSelectedBrandList(state, action) {
      if (action.payload.channel == 1) {
        state.otherSelectedBrand.amazon = action.payload.list;
      } else if (action.payload.channel == 2) {
        state.otherSelectedBrand.rakuten = action.payload.list;
      } else if (action.payload.channel == 3) {
        state.otherSelectedBrand.yahoo = action.payload.list;
      }
    },
    resetSelectedBrandList(state, action) {
      if (action.payload.channel == 1) {
        state.ownSelectedBrand.amazon = '';
        state.otherSelectedBrand.amazon = '';
      } else if (action.payload.channel == 2) {
        state.ownSelectedBrand.rakuten = '';
        state.otherSelectedBrand.rakuten = '';
      } else if (action.payload.channel == 3) {
        state.ownSelectedBrand.yahoo = '';
        state.otherSelectedBrand.yahoo = '';
      }
    },
    setOwnCheckedBrandList(state, action) {
      if (action.payload.channel == 1) {
        state.ownCheckedBrand.amazon = action.payload.list;
      } else if (action.payload.channel == 2) {
        state.ownCheckedBrand.rakuten = action.payload.list;
      } else if (action.payload.channel == 3) {
        state.ownCheckedBrand.yahoo = action.payload.list;
      }
    },
    setOtherCheckedBrandList(state, action) {
      if (action.payload.channel == 1) {
        state.otherCheckedBrand.amazon = action.payload.list;
      } else if (action.payload.channel == 2) {
        state.otherCheckedBrand.rakuten = action.payload.list;
      } else if (action.payload.channel == 3) {
        state.otherCheckedBrand.yahoo = action.payload.list;
      }
    },
    changePageCount(state, action) {
      if (action.payload === 0) {
        state.pageCount = 1;
      } else {
        state.pageCount += action.payload;
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBrandList.fulfilled, (state, action) => {
      if (action.payload.channel == 1) {
        state.brandList.amazon = action.payload.brandList;
        state.isLoading = false;
        state.allBrandLength.amazon = action.payload.brandListLength;
      } else if (action.payload.channel == 2) {
        state.brandList.rakuten = action.payload.brandList;
        state.isLoading = false;
        state.allBrandLength.rakuten = action.payload.brandListLength;
      } else if (action.payload.channel == 3) {
        state.brandList.yahoo = action.payload.brandList;
        state.isLoading = false;
        state.allBrandLength.yahoo = action.payload.brandListLength;
      }
    });
    builder.addCase(fetchBrandList.pending, (state, action) => {
      return {
        ...state,
        isLoading: true
        // error: false
      };
    });
    builder.addCase(fetchBrandList.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false
        // error: false
      };
    });
    builder.addCase(fetchSearchBrandList.fulfilled, (state, action) => {
      if (action.payload.channel === 1) {
        state.brandList.amazon = action.payload.brandList;
        state.isLoading = false;
        state.allBrandLength.amazon = action.payload.brandListLength;
      } else if (action.payload.channel === 2) {
        state.brandList.rakuten = action.payload.brandList;
        state.isLoading = false;
        state.allBrandLength.rakuten = action.payload.brandListLength;
      } else if (action.payload.channel === 3) {
        state.brandList.yahoo = action.payload.brandList;
        state.isLoading = false;
        state.allBrandLength.yahoo = action.payload.brandListLength;
      }
    });
    builder.addCase(fetchSearchBrandList.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchSearchBrandList.rejected, (state, action) => {
      state.isLoading = false;
    });
    // builder.addCase(fetchAllCategoryGraphData.fulfilled, (state, action) => {
    //   if (action.payload.channel == 1) {
    //     state.amazon_graphdata['graphdata'] = action.payload.graphdata;
    //     state.amazon_graphdata['totalsalesData'] = action.payload.sales;
    //     state.amazon_graphdata['totalunitData'] = action.payload.unit_sold;
    //     state.amazon_graphdata['selectCategoryLabel'] =
    //       action.payload.category_name;
    //     state.amazon_graphdata['lastmonthRate'] = '';
    //     state.amazon_graphdata['lastyearRate'] = '';
    //     state.isLoading = false;
    //   } else if (action.payload.channel == 2) {
    //     state.rakuten_graphdata['graphdata'] = action.payload.graphdata;
    //     state.rakuten_graphdata['totalsalesData'] = action.payload.sales;
    //     state.rakuten_graphdata['totalunitData'] = action.payload.unit_sold;
    //     state.rakuten_graphdata['selectCategoryLabel'] =
    //       action.payload.category_name;
    //     state.rakuten_graphdata['lastmonthRate'] = '';
    //     state.rakuten_graphdata['lastyearRate'] = '';
    //     state.isLoading = false;
    //   } else if (action.payload.channel == 3) {
    //     state.yahoo_graphdata['graphdata'] = action.payload.graphdata;
    //     state.yahoo_graphdata['totalsalesData'] = action.payload.sales;
    //     state.yahoo_graphdata['totalunitData'] = action.payload.unit_sold;
    //     state.yahoo_graphdata['selectCategoryLabel'] =
    //       action.payload.category_name;
    //     state.yahoo_graphdata['lastmonthRate'] = '';
    //     state.yahoo_graphdata['lastyearRate'] = '';
    //     state.isLoading = false;
    //   }
    // });
    // builder.addCase(fetchAllCategoryGraphData.pending, (state, action) => {
    //   return {
    //     ...state,
    //     isLoading: true
    //     // error: false
    //   };
    // });
    // builder.addCase(fetchAllCategoryGraphData.rejected, (state, action) => {
    //   return {
    //     ...state,
    //     graphdata: [0, 0, 0],
    //     totalsalesData: [0, 0, 0],
    //     totalunitData: [0, 0, 0],
    //     selectCategoryLabel: ['', '', ''],
    //     lastmonthRate: [0, 0, 0],
    //     lastyearRate: [0, 0, 0],
    //     isLoading: false
    //     // error: false
    //   };
    // });
  }
});

export const ownSelectedBrand = (state) => state.brand.ownSelectedBrand;
export const ownCheckedB = (state) => state.brand.ownCheckedBrand;
export const otherSelectedBrand = (state) => state.brand.otherSelectedBrand;
export const otherCheckedB = (state) => state.brand.otherCheckedBrand;
// export const selectAmazonCategoryGraph = (state) =>
//   state.categorygraph.amazon_graphdata;
// export const selectRakutenCategoryGraph = (state) =>
//   state.categorygraph.rakuten_graphdata;
// export const selectYahooCategoryGraph = (state) =>
//   state.categorygraph.yahoo_graphdata;

// export const selectCategoryFigures = (state) =>
//   state.categorygraph.salesFiguresData;
// export const currentAcate1 = (state) => state.categorygraph.a_cate1;
// export const currentAcate2 = (state) => state.categorygraph.a_cate2;
// export const currentAcate3 = (state) => state.categorygraph.a_cate3;
// export const currentAcate4 = (state) => state.categorygraph.a_cate4;
// export const currentAcate5 = (state) => state.categorygraph.a_cate5;
// export const currentAcate6 = (state) => state.categorygraph.a_cate6;
// export const currentAmazonCategoryList = (state) => [
//   state.categorygraph.a_cate1,
//   state.categorygraph.a_cate2,
//   state.categorygraph.a_cate3,
//   state.categorygraph.a_cate4,
//   state.categorygraph.a_cate5,
//   state.categorygraph.a_cate6
// ];
// export const currentRcate1 = (state) => state.categorygraph.r_cate1;
// export const currentRcate2 = (state) => state.categorygraph.r_cate2;
// export const currentRcate3 = (state) => state.categorygraph.r_cate3;
// export const currentRcate4 = (state) => state.categorygraph.r_cate4;
// export const currentRakutenCategoryList = (state) => [
//   state.categorygraph.r_cate1,
//   state.categorygraph.r_cate2,
//   state.categorygraph.r_cate3,
//   state.categorygraph.r_cate4
// ];
// export const currentYcate1 = (state) => state.categorygraph.y_cate1;
// export const currentYcate2 = (state) => state.categorygraph.y_cate2;
// export const currentYcate3 = (state) => state.categorygraph.y_cate3;
// export const currentYcate4 = (state) => state.categorygraph.y_cate4;
// export const currentYahooCategoryList = (state) => [
//   state.categorygraph.y_cate1,
//   state.categorygraph.y_cate2,
//   state.categorygraph.y_cate3,
//   state.categorygraph.y_cate4
// ];
// export const categoryLabel = (state) => state.categorygraph.selectCategoryLabel;
// export const selectSalesFigures = (state) => state.categorygraph.totalsalesData;
// export const selectUnitFigures = (state) => state.categorygraph.totalunitData;
// export const selectLastMonthRate = (state) => state.categorygraph.lastmonthRate;
// export const selectLastYearRate = (state) => state.categorygraph.lastyearRate;
// export const categorygraphStatus = (state) => state.categorygraph.isLoading;

export const {
  setOwnSelectedBrandList,
  setOwnCheckedBrandList,
  setOtherSelectedBrandList,
  setOtherCheckedBrandList,
  resetSelectedBrandList,
  changePageCount
} = brandSlice.actions;
export const brandList = (state) => state.brand.brandList;
export const allBrandLength = (state) => state.brand.allBrandLength;
export const pageCount = (state) => state.brand.pageCount;
export const brandLoading = (state) => state.brand.isLoading;
export default brandSlice.reducer;
